/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValidationStatsStatusesInner } from './ValidationStatsStatusesInner';
import {
    ValidationStatsStatusesInnerFromJSON,
    ValidationStatsStatusesInnerFromJSONTyped,
    ValidationStatsStatusesInnerToJSON,
} from './ValidationStatsStatusesInner';

/**
 * 
 * @export
 * @interface ValidationStats
 */
export interface ValidationStats {
    /**
     * 
     * @type {Array<ValidationStatsStatusesInner>}
     * @memberof ValidationStats
     */
    statuses: Array<ValidationStatsStatusesInner>;
    /**
     * 
     * @type {number}
     * @memberof ValidationStats
     */
    total: number;
}

/**
 * Check if a given object implements the ValidationStats interface.
 */
export function instanceOfValidationStats(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "statuses" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function ValidationStatsFromJSON(json: any): ValidationStats {
    return ValidationStatsFromJSONTyped(json, false);
}

export function ValidationStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statuses': ((json['statuses'] as Array<any>).map(ValidationStatsStatusesInnerFromJSON)),
        'total': json['total'],
    };
}

export function ValidationStatsToJSON(value?: ValidationStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statuses': ((value.statuses as Array<any>).map(ValidationStatsStatusesInnerToJSON)),
        'total': value.total,
    };
}

